import { SearchProps } from '~components/form-fields/search';

import { ClientInvoiceStatus } from '~lookups/models';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const searchFields = (statuses: ClientInvoiceStatus[]): SearchProps => ({
  client_name: {
    defaultShow: true,
    type: 'text-like',
    field: ['client.first_name', 'client.surname', 'client.full_name'],
    placeholder: 'Client Name',
    caption: 'Client Name',
    hidden: isEncryptionEnabled,
  },
  invoice_date: {
    defaultShow: true,
    type: 'date-range',
    field: 'invoice_date',
    caption: 'Invoice Date',
  },
  due_date: {
    defaultShow: false,
    type: 'date-range',
    field: 'due_date',
    caption: 'Due Date',
  },
  status: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'status_id',
    placeholder: 'All',
    caption: 'Status',
    options: statuses.map(({ id, name }) => ({ id, name })),
  },
});
